import { useMemo } from "react";
import { FilterTabs } from "@components/pageHeader/filters/lib";
import { useScope } from "@state/scopeContext.lib";
import type { TaskListCapabilities } from "./taskListCapabilities";

interface UseTaskAvailableFiltersArgs {
    hasCloses: boolean;
    workspaceTaskGroupIds: string[];
    capabilities: TaskListCapabilities;
}

/** The filter menu tabs a Tasks page offers. */
export const useTaskAvailableFilters = ({
    hasCloses,
    workspaceTaskGroupIds,
    capabilities,
}: UseTaskAvailableFiltersArgs) => {
    const { organizationId } = useScope();

    return useMemo(() => {
        const tabs: FilterTabs[] = [
            ...(capabilities.canFilterByAssignee
                ? [FilterTabs.TASK_ASSIGNEE]
                : []),
            ...(capabilities.canFilterByClient ? [FilterTabs.TASK_CLIENT] : []),
            FilterTabs.TASK_CREATED_BY,
            FilterTabs.TASK_CREATED_ON,
            FilterTabs.TASK_COMPLETED_BY,
            FilterTabs.TASK_COMPLETED_ON,
        ];
        if (hasCloses) {
            tabs.push(FilterTabs.TASK_CLOSE);
        }
        tabs.push(
            FilterTabs.TASK_PRIORITY,
            FilterTabs.TASK_ATTACHMENTS,
            FilterTabs.TASK_DEPENDENCIES,
            FilterTabs.TASK_CHAT,
        );
        if (workspaceTaskGroupIds.length > 0) {
            tabs.push(FilterTabs.TASK_GROUP);
        }
        if (organizationId) {
            tabs.push(FilterTabs.TASK_STAGE);
        }
        return tabs;
    }, [
        hasCloses,
        workspaceTaskGroupIds,
        organizationId,
        capabilities.canFilterByAssignee,
        capabilities.canFilterByClient,
    ]);
};
